import React, { useEffect, useState } from "react";
import Input from "../../../Components/Input/Input";
import { getViewAirline, getViewCountry, updateAirline, UpdateCountry } from "../../../utils/api";
import { useParams } from "react-router-dom";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp";
import { isEmpty } from "../../../utils/common";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";

const ViewAirlineDetails = () => {
  const { id } = useParams();
  const [viewHotelData, setViewHotelData] = useState({});
  const [errors, setErrors] = useState({});
const [message,setMessage] = useState("");

  const viewHotel = () => {
    const param =  id ;
    getViewAirline(param).then((response) => {
      setViewHotelData(response?.data?.data || {});
    });
  };

  useEffect(() => {
    viewHotel();
  }, []);

  const validateFields = () => {
    let isValid = true;
    const newErrors = {};

    if (!viewHotelData.name || viewHotelData.name.trim() === "") {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!viewHotelData.code || viewHotelData.code.trim() === "") {
      newErrors.code = "code is required.";
      isValid = false;
    }

    if (viewHotelData.active === undefined || viewHotelData.active === "") {
      newErrors.active = "Status is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleUpdate = () => {
    if (validateFields()) {
      const param = { id, ...viewHotelData };
      updateAirline(param).then((resp) => {
        if(resp){
            setMessage({type:"success",message:"Airline updated successfully!"});
        }
        
      }).catch(() => {
        setMessage({type:"error",message:"Update Fialed"});
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setViewHotelData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    
    <div style={{ padding: "30px" }}>
      {!isEmpty(message) && (
                          <AlertWrapper className={`${message.type} globle`}>
                            <span className="close" onClick={() => setMessage({})}>
                              ×
                            </span>
                            {message.message}
                          </AlertWrapper>
                        )}
    
        
      <div className="container column flex gap-50">
        <div>
          <div className="flex gap-10">
            <div>
              <div className="labelname mb-5">
                <label className="fw-bold">Name</label>
              </div>
              <Input
                type="text"
              
                placeholder="Name"
                name="name"
                value={viewHotelData?.name || ""}
                onChange={handleInputChange}
              />
              {errors.name && <p className="error fs-12 mt-10">{errors.name}</p>}
            </div>

            <div className="input-field">
              <div className="labelname mb-5">
                <label className="fw-bold">Status:</label>
              </div>
              <select
                style={{ width: "330px" }}
                className="input_select_field"
                name="active"
                value={viewHotelData?.active || ""}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                <option value={true}>ACTIVE</option>
                <option value={false}>INACTIVE</option>
              </select>
              {errors.active && <p className="error fs-12 mt-10">{errors.active}</p>}
            </div>
          </div>

          <div className="flex gap-10 mt-20">
            <div>
              <div className="labelname mb-5">
                <labe className ="fw-bold">Code:</labe>
              </div>
              <Input
                type="text"
                maxLength={10}
                placeholder="Code"
                name="iso2"
                value={viewHotelData?.code || ""}
                onChange={handleInputChange}
              />
              {errors.iso2 && <p className="error fs-12 mt-10">{errors.iso2}</p>}
            </div>
            

          
          </div>

        </div>

        <div>
          <button onClick={handleUpdate} className="userlist_btn">
            Update Airline
          </button>
        </div>
      </div>
   
   
    </div>
  );
};

export default ViewAirlineDetails;
